import { Injectable } from '@angular/core';
import { UserRequestModel, UserViewModel } from '../business-entities/user-view-model';
import { ReceptionDataService } from '../data-services/reception-data.service';

@Injectable({
  providedIn: 'root'
})
export class ReceptionService {

  userId:string;
  receptionId: number;
  userDetails:UserViewModel;
  isEdit: boolean = false;
  constructor(private receptionDataService: ReceptionDataService) { }

  async getUserList(userRequestModel:UserRequestModel) {
    return this.receptionDataService.getUserList(userRequestModel);
  }

  addUpdateUser(userDetails: UserViewModel) {
    return this.receptionDataService.addUpdateUser(userDetails);
  }

  async getUserDetail(Id: string): Promise<any> {
    return this.receptionDataService.getUserDetail(Id);
  }

  //   updateDealer(dealerDetails: DealerViewModel) {
  //     return this.dealerDataService.updateDealer(dealerDetails);
  // }

  deleteUser(id: string) {
    return this.receptionDataService.deleteUser(id);
  }
  getCreatedByUserList(isCdss:boolean){
    return this.receptionDataService.getCreatedByUserList(isCdss);
  }
}
